import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-problem',
  standalone: true,
  templateUrl: './problem.component.html',
  styleUrls: ['./problem.component.css']
})
export class ProblemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
